import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
import AdminLayout from "./layouts/AdminLayout";

import Home from "./pages/Home";
import ComoFunciona from "./pages/ComoFunciona";
import Precos from "./pages/Precos";
import Demo from "./pages/Demo";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import Privacidade from "./pages/Privacidade";
import Termos from "./pages/Termos";
import NotFound from "./pages/NotFound";
import OAuthCallback from "./pages/OAuthCallback";
import UserHome from "./pages/UserHome";
import Simulador from "./pages/Simulador";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSimulacoes from "./pages/admin/AdminSimulacoes";
import AdminUsuarios from "./pages/admin/AdminUsuarios";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminConfiguracoes from "./pages/admin/AdminConfiguracoes";
import AdminLeiloeiros from "./pages/admin/AdminLeiloeiros";
import AdminLaborCosts from "./pages/admin/AdminLaborCosts";
import AdminLogin from "./pages/admin/AdminLogin";

import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AdminRoute } from "./components/auth/AdminRoute";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public site routes */}
          <Route element={<RootLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/precos" element={<Precos />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/simulador" element={<Simulador />} />

            <Route
              path="/userhome"
              element={
                <ProtectedRoute>
                  <UserHome />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Admin panel — own layout, no Header/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="simulacoes" element={<AdminSimulacoes />} />
              <Route path="usuarios" element={<AdminUsuarios />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="configuracoes" element={<AdminConfiguracoes />} />
              <Route path="leiloeiros" element={<AdminLeiloeiros />} />
              <Route path="mao-de-obra" element={<AdminLaborCosts />} />
            </Route>
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
